import React from 'react'
import styled from 'styled-components'
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync'

import * as Table from '../components/Table'
import * as Spreadsheets from '../components/Spreadsheets'
import ScrollWrapper from '../contexts/ScrollWrapper'

const Root = styled.div`
  width: 100%;
  height: calc(100% - 56px);
  position: relative;

  display: grid;
  grid-template-columns: minmax(50%, 1fr) auto;
  grid-template-rows: 100%;

  ${Table.Tr} {
    border-right: 1px solid #404040;
  }

  ${Table.TBody}::-webkit-scrollbar,
  ${Spreadsheets.Body}::-webkit-scrollbar {
    display: none;
  }
`

const Scroller = styled.div`
  display: flex;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    display: none;
  }
`

/** @type {(props: { children?: React.ReactNode }) => React.ReactNode} */
const Wrapper = props => <ScrollSyncPane>{props.children}</ScrollSyncPane>

export default {
  /** @type {typeof Root} */
  Root: props => ((
    <ScrollSync>
      <ScrollWrapper.Provider value={ Wrapper }>
        <Root { ...props } />
      </ScrollWrapper.Provider>
    </ScrollSync>
  )),
  Scroller,
}



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/layout/Splitscreen.jsx